// Leads go straight to Adel OS (US / EN market).
// REACT_APP_API_URL — base (default app.agent.adel.company)
// REACT_APP_LEAD_TOKEN — same as adel-os LEAD_INGEST_TOKEN (or an extra LEAD_INGEST_TOKENS value)
const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  'https://app.agent.adel.company'
).replace(/\/$/, '')

const LEAD_TOKEN = (process.env.REACT_APP_LEAD_TOKEN || '').trim()

function submitLeadUrl() {
  const path = `${API_BASE_URL}/api/submit-lead`
  if (!LEAD_TOKEN) return path
  const qs = new URLSearchParams({ token: LEAD_TOKEN })
  return `${path}?${qs.toString()}`
}

function withToken(path) {
  const url = `${API_BASE_URL}${path}`
  if (!LEAD_TOKEN) return url
  const qs = new URLSearchParams({ token: LEAD_TOKEN })
  return `${url}?${qs.toString()}`
}

export const API_ENDPOINTS = {
  SUBMIT_LEAD: submitLeadUrl(),
  DEMO_SLOTS: `${API_BASE_URL}/api/public/demo-slots?region=EN`,
  BOOK_DEMO: withToken('/api/public/book-demo'),
  SITE_CHAT: withToken('/webhooks/site-chat'),
}

export { API_BASE_URL }
